export function splitTableCells(line_) {
  let working = line_.trim();
  if (working.startsWith("|")) {
    working = working.slice(1);
  }
  if (working.endsWith("|")) {
    working = working.slice(0, -1);
  }

  const cells = [];
  let buffer = "";
  let escape = false;

  for (const char of working) {
    if (escape) {
      buffer += char;
      escape = false;
      continue;
    }
    if (char === "\\") {
      escape = true;
      continue;
    }
    if (char === "|") {
      cells.push(buffer.trim());
      buffer = "";
      continue;
    }
    buffer += char;
  }
  cells.push(buffer.trim());
  return cells;
}

export function parseAlignmentRow(line_) {
  const cells = splitTableCells(line_);
  if (cells.length === 0) {
    return null;
  }
  const alignments = [];
  for (const rawCell of cells) {
    const cell = rawCell.replace(/\s+/g, "");
    if (!/^:?-{3,}:?$/.test(cell)) {
      return null;
    }
    let align = null;
    const startsWithColon = cell.startsWith(":");
    const endsWithColon = cell.endsWith(":");
    if (startsWithColon && endsWithColon) {
      align = "center";
    } else if (endsWithColon) {
      align = "right";
    } else if (startsWithColon) {
      align = "left";
    }
    alignments.push(align);
  }
  return alignments;
}
